import { AU_KM, heliocentricEcliptic, norm } from "@solar/ephemeris";
import { useScene, useTimeMs } from "../store";
import { bodyName, useT } from "../i18n";

export function TopBar() {
  const { t, lang } = useT();
  const { selected, setLang } = useScene();
  const ms = useTimeMs(200);
  let dist = "—", light = "—";
  if (selected && selected !== "sun") {
    const r = norm(heliocentricEcliptic(selected, new Date(ms)));
    dist = `${r.toFixed(3)} AU`;
    const lm = (r * AU_KM) / 299792.458 / 60;
    light = lm < 1 ? `${(lm * 60).toFixed(0)} ${t("sec")}` : lm < 90 ? `${lm.toFixed(1)} ${t("min")}` : `${(lm / 60).toFixed(1)} ${t("hour")}`;
  }
  return (
    <div className="top">
      <div className="pill glass">
        <span>{t("focus")} <b>{selected ? bodyName(selected, lang) : t("none")}</b></span>
        <span>{t("distance")} <b className="num">{dist}</b></span>
        <span>{t("lightTime")} <b className="num">{light}</b></span>
      </div>
      <div className="rgroup">
        <div className="pill glass">
          <span><kbd>W</kbd><kbd>A</kbd><kbd>S</kbd><kbd>D</kbd> {t("move")}</span>
          <span><kbd>Q</kbd><kbd>E</kbd> {t("updown")}</span>
          <span><kbd>F</kbd> {t("focus")}</span>
          <span><kbd>T</kbd> {t("today")}</span>
          <span><kbd>{t("space")}</kbd> {t("play")}</span>
        </div>
        <div className="pill glass lang">
          <button className={lang === "zh" ? "on" : ""} onClick={() => setLang("zh")}>中文</button>
          <button className={lang === "en" ? "on" : ""} onClick={() => setLang("en")}>EN</button>
        </div>
      </div>
    </div>
  );
}
